import { render, staticRenderFns } from "./edit-password.vue?vue&type=template&id=b51a294c&scoped=true&"
import script from "./edit-password.vue?vue&type=script&lang=js&"
export * from "./edit-password.vue?vue&type=script&lang=js&"
import style0 from "./edit-password.vue?vue&type=style&index=0&id=b51a294c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51a294c",
  null
  
)

export default component.exports